import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Link from '../../../Link';
import { TenantContext } from '../../../../contexts/TenantContext';
import Logo from '../../../../assets/app-only/images/logo.svg';

interface BrandProps {
  sidebarExpanded: boolean;
}

const Brand: React.FC<BrandProps> = ({ sidebarExpanded }) => {
  const { t } = useTranslation();
  const { tenantInfo } = useContext(TenantContext);
  const [imageError, setImageError] = useState(false);

  const logoSrc = tenantInfo?.logo_path && !imageError
    ? tenantInfo.logo_path
    : Logo;

  return (
    <div className="app-brand app-brand-custom demo">
      <Link
        className="app-brand-link"
        icon={
          <img
            src={logoSrc}
            className="app-brand-logo app-brand-logo-custom demo"
            alt={tenantInfo?.name || t('layout.pageTexts.private.sidebar.logoAltText')}
            onError={() => setImageError(true)}
            data-app-light-img={logoSrc}
            data-app-dark-img={logoSrc}
          />
        }
      />
    </div>
  );
};

export default Brand;
